<div
  class="document-category-identifier-icon-container"
  tiimeTooltip
  [tooltipContent]="documentCategoryNameTooltipTemplate"
>
  <img
    [src]="documentCategory?.identifier | map: mapToDocumentCategoryIdentifierIcon : documentCategory?.owner"
    alt="icône espace"
  />
  @if (documentCategory?.owner === DocumentCategoryOwner.accountant) {
    <mat-icon fontSet="fontastic" fontIcon="icon-accountant-tag-fontastic-18"></mat-icon>
  }
</div>
<ng-template #documentCategoryNameTooltipTemplate>
  Espace
  @if (documentCategory?.owner === DocumentCategoryOwner.accountant) {
    Expert-comptable
  } @else {
    Client
  }
  : {{ documentCategory?.name }}
</ng-template>
